import React, { useCallback, useEffect, useState } from "react";
import styled from 'styled-components';
import theme from "../../styles/theme";
import { ExpandLess } from "@mui/icons-material";
import { Autocomplete, Button, Collapse, TextField } from "@mui/material";

import CommonTab from "../common/CommonTab";
import { useGetTargetCodeList } from "../../interfaces/common";
import TimeTable from "./TimeTable";
import { useGetProjectPointList, useSetProjectPointTimeTable } from "../../interfaces/point";
import PointDetail from "./PointDetail";
import { MODAL_QUERY_NM } from "../../interfaces/modal";
import { useQueryClient } from "react-query";
import PointSetupTime from "./PointSetupTime";
import PointCodingTime from "./PointCodingTime";
import PointCounter from "./PointCounter";

const MainWrap = styled.div`
    width: 100%;
    padding-top: 1rem;
    height: 100%;
`;
const TitleArea = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
`;
const SubWrap = styled.div`
    width: 100%;
    height: 100%;
    max-height: 100%;
    display: grid;
    grid-template-columns: 20rem auto;
    gap: 0.5rem;
    overflow: hidden;
`;
const ListArea = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100%;
    overflow:hidden;
`;

const DetailArea = styled.div`
    border-left: 1px solid ${theme.color.black[10]};
    padding: 0 0.5rem;
    padding-top: 0;
    font-size: 1.2rem;
    display: grid;
    gap: 0.5rem;
    grid-template-rows: 2rem auto;
    height: 100%;
    max-height: 100%;
    overflow:hidden;
    .listBox {
        padding: 0 0.5rem;
        height: 100%;
        max-height: 100%;
        overflow: hidden;;
    }
`;

const TitleLine = styled.ul`
    list-style-type: none;
    padding:0;
    // padding: 0 0.4rem;
    margin:0;
    border-bottom:2px solid ${theme.color.black[40]};
    li {
        display: grid;
        // grid-template-columns: 2rem 14rem 2rem 4rem 4rem 3rem 3rem 20rem 22rem 10rem;
        grid-template-columns: 2rem 14rem;
        gap: 0.8rem;
        font-size: 1rem;
        font-weight: bold;
        line-height: 2rem;
        height: 2rem;
    }
`;

const DescArea = styled.ul`
    flex-grow: 1;
    list-style-type: none;
    width: 100%;
    max-height: 100%;
    padding: 0;
    margin: 0;
    cursor: pointer;
    overflow:auto;
    .descLiItem  {
        width: 100%;
        gap: 0.8rem;
        font-size: 1rem;
        line-height: 2rem;
        height: 2rem;
        border-bottom: 1px solid ${theme.color.black[20]};
        display: grid;
        grid-template-columns: 2rem 14rem;
        gap: 1rem;
        span:nth-child(1) {
            text-align: right;
        }
    }
    .descLiItem:last-child{
        border: 0;
    }
    .selected {
        background: ${theme.color.primary.pupple2};
    }
`;

const PointList = ({survey}) => {

    const queryClient = useQueryClient();

    const [list, setList] = useState();

    const [detail, setDetail] = useState();

    const [tabIndex, setTabIndex] = useState(0);
    const [pointTpList, setPointTpList] = useState([]);
    const [setComplete, setSetComplete] = useState(false);

    const {data, refetch} = useGetProjectPointList(survey && survey.sid);
    const {data:point_tp} = useGetTargetCodeList('point_tp');

    useEffect(()=>{
        refetch();
    },[survey])

    useEffect(()=>{
        data ? setList(data) : setList();
    },[data])

    useEffect(()=>{
        list ? handleItemClick(0) : handleItemClick(-1);
    },[list])

    useEffect(()=>{
        if(point_tp){
            setPointTpList(point_tp.map((item,index)=>({
                ...item,
                label:item.value})
                ));
        }
    },[point_tp])

    const handleItemClick = (index) => {
        if(index > -1){
            const temp = list[index];
            if(temp && temp.inputs_timeset){
                const itTemp = JSON.parse(temp.inputs_timeset)
                if(itTemp && itTemp.length>0 && itTemp[0].seq > 0){
                    setDetail({...temp,inputs_timeset:itTemp});
                }else{
                    setDetail({...temp,inputs_timeset:null});
                }
            }else{
                setDetail({...temp,inputs_timeset:undefined})
            }
        }else{
            setDetail()
        }
        setSetComplete(true);
    }

    return (
        <MainWrap>
            <SubWrap>
                <ListArea>
                    <TitleLine>
                        <li>
                            <span>&nbsp;</span>
                            <span>지점명</span>
                        </li>
                    </TitleLine>
                    <DescArea>
                        {list && list.length > 0 &&
                            list.map((item,index)=>(
                                <li key={index} className={'descLiItem '+(detail && detail.tid === item.tid ? 'selected' : '') } onClick={()=>handleItemClick(index)}>
                                    <span>{index+1}</span>
                                    <span>{item.snm}</span>
                                </li>
                            ))
                        }
                    </DescArea>
                    <Button variant='contained' style={{width:'100%'}} onClick={()=>setDetail(undefined)}>지점 추가</Button>
                </ListArea>
                <DetailArea>
                    <CommonTab tabList={detail ? ['기본정보','촬영시간','코딩시간','카운터 설정'] : ['기본정보']} onClick={setTabIndex}/>
                    <div style={{height:'100%',overflow:'auto'}}>
                    {tabIndex === 0 && <PointDetail sid={survey.sid} detail={detail} pointTpList={pointTpList} />}
                    {tabIndex === 1 && <PointSetupTime survey={survey} tid={detail && detail.tid}/>}
                    {tabIndex === 2 && <PointCodingTime survey={survey} tid={detail && detail.tid}/>}
                    {tabIndex === 3 && <PointCounter tid={detail && detail.tid} />}
                    </div>
                </DetailArea>
            </SubWrap>
        </MainWrap>
    )
}

export default PointList;